import { render } from "./GarantePayDashboard.vue?vue&type=template&id=6a39c4c0&scoped=true"
import script from "./GarantePayDashboard.vue?vue&type=script&lang=js"
export * from "./GarantePayDashboard.vue?vue&type=script&lang=js"

import "./GarantePayDashboard.vue?vue&type=style&index=0&id=6a39c4c0&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a39c4c0"]])

export default __exports__